import { Component } from '@angular/core';
import { ActiveService } from "@modules/private/active/data/services/view/active.service";

@Component({
  selector: 'app-active-form',
  templateUrl: './active-form.component.html',
  styleUrls: ['./active-form.component.scss']
})
export class ActiveFormComponent {
  categories: { label: string; value: string; }[] = [
    { label: "Vehiculos", value: "Vehiculos" },
    { label: "Tecnología", value: "Tecnología" },
    { label: "Maquinaria", value: "Maquinaria" },
    { label: "Inmuebles", value: "Inmuebles" },
    { label: "Otros", value: "Otros" }
  ]
  
  constructor(
    public activeService: ActiveService
  ) {
  }

  get e() {
    return this.activeService.entity
  }

  getNameCategory(id: string) {
    return this.categories.find(c => c.value === id)?.label
  }

  calculateAcquisitionValues(total: number) {
    if (total >= 0) {
      const amount: number = total / 1.16
      const iva: number = total - amount

      this.e.get('acquisition')?.patchValue({ 
        amount: amount.toFixed(2), 
        iva: iva.toFixed(2), 
        total: total.toFixed(2) 
      });
      
    } else {
      this.e.get('acquisition')?.patchValue({ amount: '', iva: '', total: '' });
    }
  }
}
